import { Button } from "#/components/button/button";
import { Input } from "#/components/input/input";
import { authErrorMessage, resetPassword } from "#/feature/auth/auth-api";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import {
  buttonStyles,
  containerStyles,
  contentStyles,
  errorStyles,
  fieldStyles,
  footerStyles,
  formStyles,
  inputStyles,
  labelStyles,
  linkStyles,
  titleStyles,
} from "./login.css";

export function ForgotPasswordPage() {
  const [username, setUsername] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await resetPassword(username, code, newPassword);
      void navigate("/login");
    } catch (err) {
      setError(authErrorMessage(err, "Password reset failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={containerStyles}>
      <div className={contentStyles}>
        <h1 className={titleStyles}>Reset password</h1>
        <p style={{ fontSize: "0.875rem", textAlign: "center", marginBottom: "1rem" }}>
          Requires an authenticator app linked to your account.
        </p>
        {error && <div className={errorStyles}>{error}</div>}
        <form onSubmit={handleSubmit} className={formStyles}>
          <div className={fieldStyles}>
            <label className={labelStyles}>Username</label>
            <Input
              className={inputStyles}
              type="text"
              value={username}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className={fieldStyles}>
            <label className={labelStyles}>Authenticator code</label>
            <Input
              className={inputStyles}
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              value={code}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCode(e.target.value)}
              required
            />
          </div>
          <div className={fieldStyles}>
            <label className={labelStyles}>New password</label>
            <Input
              className={inputStyles}
              type="password"
              value={newPassword}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <Button type="submit" fullWidth className={buttonStyles} disabled={loading}>
            Reset password
          </Button>
        </form>
        <div className={footerStyles}>
          <Link to="/login" className={linkStyles}>
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
}
